export default "/images/60ce0a5ec1fe8819dd2b370da20c3ae3.avif";